import { jsx as e } from "@emotion/react/jsx-runtime";
import { CountText as a } from "./Count.styled.js";
const c = ({
  value: r,
  hasError: s,
  disabled: t = !1,
  characterCount: o
}) => {
  const n = o ? !!(r && r.length > o) : !1;
  return /* @__PURE__ */ e(a, { as: "div", variant: "bodySRegular", color: s || n ? "danger" : "secondary", disabled: t, children: `${r ? r.length : 0} / ${o}` });
};
export {
  c as CharacterCount
};
